import { Injectable } from '@angular/core';
import type { AuthResponse } from '../app.types';

const TOKEN_KEY = 'qrRouterToken';
const EMAIL_KEY = 'qrRouterEmail';
const COOKIE_PREF_KEY = 'qrRouterCookiePreference';

@Injectable({ providedIn: 'root' })
export class AuthSessionService {
  get token(): string {
    return localStorage.getItem(TOKEN_KEY) || '';
  }

  set token(value: string) {
    localStorage.setItem(TOKEN_KEY, value);
  }

  get email(): string {
    return localStorage.getItem(EMAIL_KEY) || '';
  }

  set email(value: string) {
    localStorage.setItem(EMAIL_KEY, value);
  }

  storeAuth(response: AuthResponse): void {
    this.token = response.token;
    this.email = response.user.email;
  }

  clear(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(EMAIL_KEY);
  }

  authHeaders(): Record<string, string> {
    const token = this.token;
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  saveCookiePreference(value: 'all' | 'necessary'): void {
    localStorage.setItem(COOKIE_PREF_KEY, value);
  }
}

